import { addPaddingOnTeaserContent, debounceEvent } from '../../../js/utils';
let context;
export default class CmsCountdown {
  constructor(endDate, elementSelector = '.swa-cms-countdown') {
    this.endDate = new Date(endDate);
    this.elementSelector = elementSelector;
  }

  //calculate plp teaser padding and plp teaser new image margin when intersecting, if page is not loaded from the top
  scrollObserver() {
    let observer;
    let options;

    options = {
      rootMargin: '0px 0px 100px 0px'
    };

    context = this;
    observer = new IntersectionObserver(this.handleIntersect, options);
    this.observer = observer;
    this.observer.observe(document.querySelector(this.elementSelector));
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (context.plpTopTeaserNew && context.countdownHeaderPosition) {
          const countdownElement = document.querySelector(context.elementSelector);
          addPaddingOnTeaserContent(context.plpTopTeaserContent, countdownElement); // if plp new and countdown inside header
        } else {
          addPaddingOnTeaserContent(context.plpTopTeaserContent); // if no plp new teaser or plp new teaser with countdown outside header
        }
      }
    });
  }

  init() {
    const countdownElement = document.querySelector(this.elementSelector);
    if (!countdownElement) return;

    this.plpTopTeaserNew = document.querySelector('.swa-plp-top-teaser--new');//new modifier class for plp top teaser wrapper, which will replace the wrapper one with the cleanup ticket
    this.plpTopTeaserContent = document.querySelector('.js-swa-plp-top-teaser-content');
    this.countdownHeaderPosition = document.querySelector('.js-swa-cms-countdown-header-position');
    this.header = document.querySelector('.swa-header');

    const closeButton = document.querySelector(`${this.elementSelector}__close-container`);
    closeButton && closeButton.addEventListener('click', () => this.hideCountdown(countdownElement));

    /* If the end date of the countdown timer is not a valid date,
    the countdown element is hidden and a error message is pushed to the data layer.*/
    if (!this.isValidDate()) {
      this.hideCountdown(countdownElement);
      window.dataLayer.push({
        event: 'caughtError',
        errorType: 'Countdown timer error',
        errorMsg: this.endDate
      });
      return;
    }

    /* Sets up an interval (updateCountdown) that updates the time remaining in the countdown every 1000 milliseconds (1 second).
    It calculates the time remaining (in days, hours, minutes, and seconds) by subtracting the current time from the end time.
    This information is then displayed in the respective HTML elements.*/
    const updateCountdown = setInterval(() => {
      const now = new Date().getTime();
      const distance = this.endDate.getTime() - now;

      if (distance <= 0) {
        clearInterval(updateCountdown);
        this.hideCountdown(countdownElement);
      }

      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      //Checking if the value has changed before updating the HTML
      const daysElement = document.querySelector(this.elementSelector + '__days');
      if (daysElement) {
        if (daysElement.innerHTML !== days) daysElement.innerHTML = days;
      }

      const hoursElement = document.querySelector(this.elementSelector + '__hours');
      if (hoursElement) {
        if (hoursElement.innerHTML !== hours) hoursElement.innerHTML = hours;
      }

      const minutesElement = document.querySelector(this.elementSelector + '__minutes');
      if (minutesElement) {
        if (minutesElement.innerHTML !== minutes) minutesElement.innerHTML = minutes;
      }

      const secondsElement = document.querySelector(this.elementSelector + '__seconds');
      if (secondsElement) {
        if (secondsElement.innerHTML !== seconds) secondsElement.innerHTML = seconds;
       }

    }, 1000);

    this.toggleContainer(countdownElement);

    if (this.header && this.header.classList.contains('js-swa-header-transparent')) {
      this.addWindowResizeListener();

      setTimeout(() => {
        this.scrollObserver();
      }, 300); // timeout needed for existing header and PLP top teaser transitions on the page
    }
  }

  //calculate plp teaser padding and plp teaser new image margin at resize if countdown is placed inside header wrapper
  addWindowResizeListener() {
    window.addEventListener(
      'resize', debounceEvent(() => {
        if (this.plpTopTeaserNew && this.countdownHeaderPosition) {
          const countdownElement = document.querySelector(this.elementSelector);
          addPaddingOnTeaserContent(this.plpTopTeaserContent, countdownElement);
        }
      }, 250)
    );
  }

  // adds the "swa-hidden"class to countdownElement, effectively hiding it
  hideCountdown(countdownElement) {
    countdownElement.classList.add('swa-hidden');

    if (this.header && this.header.classList.contains('js-swa-header-transparent')) {
      if (this.plpTopTeaserNew && this.countdownHeaderPosition) {
        addPaddingOnTeaserContent(this.plpTopTeaserContent, countdownElement); // if plp new teaser and countdown inside header
      } else if(!this.plpTopTeaserNew) {
        addPaddingOnTeaserContent(this.plpTopTeaserContent); // if plp teaser old implementation
      }
    }
  }

  // check if the end date passed to the constructor is a valid date
  isValidDate() {
    return this.endDate instanceof Date && !isNaN(this.endDate.getTime());
  }

  // toggleContainer is called to add the click event listener to the countdown element to reveal the extended container when clicked
  toggleContainer(countdownElement) {
    const bannerExtended = document.querySelector('.swa-cms-countdown__extended');
    const closeButton = document.querySelector('.swa-cms-countdown__close-icon');
    const cmsLinkButtons = document.querySelector('.swa-cms-countdown__buttons');

    countdownElement.onclick = (event) => {
      if (event.target === closeButton || event.target === cmsLinkButtons ) {
        return;
      }

      bannerExtended.classList.toggle('swa-cms-countdown__extended--visible');

      if (this.header && this.header.classList.contains('js-swa-header-transparent')) {
        if (this.plpTopTeaserNew && this.countdownHeaderPosition) {
          addPaddingOnTeaserContent(this.plpTopTeaserContent, countdownElement); // if plp new teaser and countdown inside header
        } else if (!this.plpTopTeaserNew) {
          addPaddingOnTeaserContent(this.plpTopTeaserContent); // if plp teaser old implementation
        }
      }
    };
  }
}
